import type { PayBreakdownLine } from "@crewledger/shared/schemas";
import { formatCurrency, formatHours } from "@/features/dashboard/utils";

const CATEGORY_LABELS: Record<string, string> = {
  regular: "Regular",
  overtime: "OT",
  double_time: "DT",
  holiday: "Holiday",
  premium_night: "Night premium",
  premium_hazard: "Hazard premium",
  premium_training: "Training premium",
  equipment: "Equipment",
};

export function breakdownCategoryLabel(category: string): string {
  return CATEGORY_LABELS[category] ?? category;
}

export function formatBreakdownLine(line: PayBreakdownLine, canViewPayroll = true): string {
  const label = breakdownCategoryLabel(line.category);

  if (!canViewPayroll) {
    return `${label}: ${formatHours(line.hours)}`;
  }

  if (line.category === "equipment") {
    return `${label}: ${line.description}, ${formatHours(line.hours)} × ${formatCurrency(line.rate)}`;
  }

  if (line.category.startsWith("premium_")) {
    const pct = Math.round((line.multiplier - 1) * 100);
    return `${label}: ${formatHours(line.hours)} × ${pct}%`;
  }

  return `${label}: ${formatHours(line.hours)} × ${formatCurrency(line.rate)} × ${line.multiplier}`;
}

export function splitBreakdownLines(breakdown: PayBreakdownLine[]) {
  return {
    labor: breakdown.filter((line) => !line.isSiteCost && line.category !== "equipment"),
    equipment: breakdown.filter((line) => line.isSiteCost || line.category === "equipment"),
  };
}
